<template>
  <div class="jin-activity">
    <div v-for="(item,index) in activityList" :key="index" class="jin-activity-item">
      <div class="jin-activity-title">
        <div class="title">{{ item.title }}</div>
        <div class="title-en">{{ item.titleEn }}</div>
        <div class="des">{{ item.des }}</div>
      </div>
      <div class="jin-activity-content">
        <div :class="item.imgWrap0ClassName">
          <img v-for="(src,i) in item.imgWrap0Arr" :key="i" v-lazy="src" alt="">
        </div>
        <div v-if="item.imgWrap1ClassName" :class="item.imgWrap1ClassName">
          <img v-for="(src,i) in item.imgWrap1Arr" :key="i" v-lazy="src" alt="">
        </div>
      </div>
    </div>
    <img v-lazy="require('@/assets/index/activity/背景元素-1@2x.png')" class="left-icon">
    <img v-lazy="require('@/assets/index/activity/背景元素-2@2x.png')" class="right-icon">
    <img v-lazy="require('@/assets/index/activity/漂浮元素@2x.png')" class="left-bottom-icon">
    <img v-lazy="require('@/assets/index/activity/漂浮元素2@2x.png')" class="right-bottom-icon">
  </div>
</template>

<script>
export default {
  data() {
    return {
      activityList: [
        {
          title: '旅游活动',
          titleEn: 'Travel and Trips',
          des: '世界很大，和小伙伴走出办公室，一起出发，去看美好山河。',
          imgWrap0ClassName: 'one-img',
          imgWrap0Arr: [require('@/assets/mobile/activity/旅游活动-1@2x.png')],
          imgWrap1ClassName: 'two-img',
          imgWrap1Arr: [
            require('@/assets/mobile/activity/旅游活动-2@2x.png'),
            require('@/assets/mobile/activity/运动活动-3@2x.png')
          ]
        },
        {
          title: '年度盛典',
          titleEn: 'Annual Event',
          des: '年度狂欢，庆祝彼此成功共享团队荣耀。',
          imgWrap0ClassName: 'one-left-img',
          imgWrap0Arr: [
            require('@/assets/mobile/activity/年度盛典-1@2x.png')
          ],
          imgWrap1ClassName: 'two-right-img',
          imgWrap1Arr: [
            require('@/assets/mobile/activity/年度盛典-2@2x.png'),
            require('@/assets/mobile/activity/年度盛典-3@2x.png')
          ]
        },
        {
          title: '节日派对',
          titleEn: 'Holiday Parties',
          des: 'Party Time！吃吃喝喝High翻天！',
          imgWrap0ClassName: 'two-top-img',
          imgWrap0Arr: [
            require('@/assets/mobile/activity/节日派对-1@2x.png'),
            require('@/assets/mobile/activity/节日派对-2@2x.png')],
          imgWrap1ClassName: 'two-bottom-img',
          imgWrap1Arr: [
            require('@/assets/mobile/activity/节日派对-3@2x.png'),
            require('@/assets/mobile/activity/节日派对-4@2x.png')
          ]
        },
        {
          title: '党建活动',
          titleEn: 'Party Building Activities',
          des: '学习党的思想，团结一心，共创美好明天。',
          imgWrap0ClassName: 'only-one-img',
          imgWrap0Arr: [require('@/assets/mobile/activity/党建活动@2x.png')],
          imgWrap1ClassName: '',
          imgWrap1Arr: []
        },
        {
          title: '运动活动',
          titleEn: 'Sports Activities',
          des: '健康生活，快乐运动，让我们一起动起来！',
          imgWrap0ClassName: 'one-big-img',
          imgWrap0Arr: [require('@/assets/mobile/activity/运动活动-1@2x.png')],
          imgWrap1ClassName: 'two-small-img',
          imgWrap1Arr: [
            require('@/assets/mobile/activity/运动活动-2h5@2x.png'),
            require('@/assets/mobile/activity/运动活动-3h5@2x.png')
          ]
        }
      ]

    }
  }
}
</script>

<style lang="scss" scoped>
.jin-activity {
  position: relative;
    .left-icon {
    position: absolute;
    left: 0;
    top: 380px;
    width: 162px;
  }
  .right-icon {
    position: absolute;
    right: 0;
    top: 380px;
    width: 182px;
  }
  .left-bottom-icon {
    position: absolute;
    left: 0;
    top: 824px;
    width: 70px;
  }
  .right-bottom-icon {
    position: absolute;
    right: 0;
    top: 1234px;
    width: 70px;
  }
.jin-activity-item {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    padding-bottom:54px;
    background: #fff;
    overflow: hidden;
    div {
      box-sizing: border-box;
    }
    .jin-activity-title {
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      font-size: 11px;
      color: #787B8A;
      line-height: 16px;
      margin-bottom: 18px;
       .title {
          height: 27px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #3D4351;
          line-height: 27px;
          letter-spacing: 0px;
        }
        .title-en {
          font-family: PingFangSC-Medium, PingFang SC;
          margin: 2px 0 4px;
          height: 16px;
        }
        .des {
          height: 16px;
        }
    }
    .jin-activity-content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 339px;
      height: 100%;
      margin: 0 auto;
        img {
          position: relative;
          width: 100%;
          height: 100%;
          z-index: 1
        }
        .one-img {
          width: 100%;
          height: 72px;
          margin-bottom: 6px;
        }
        .one-big-img {
          width: 100%;
          height: 96px;
          margin-bottom: 6px;
        }
        .two-img,.two-small-img {
          display: flex;
          justify-content: space-between;
          width: 339px;
          height: 96px;
          img {
            width: 166px;
            height: 100%;
          }
        }
        .two-small-img {
          height: 95px;
        }
        .one-left-img {
          width: 163px;
          height: 130px;
        }
        .two-right-img {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 170px;
          height: 130px;
          img {
            width: 100%;
            height: 62px;
          }
        }
        .two-top-img,.two-bottom-img {
          display: flex;
          justify-content: space-between;
          width: 100%;
          height: 96px;
          margin-bottom: 6px;
          img {
            width: 166px;
          }
        }
        .only-one-img {
          width: 100%;
          height: 159px;
        }
    }
}
}
</style>
